<template>
    <div class="it-services-banner" id="banner">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="main-banner-content">
                        <h1>Optimizăm prezentul.<br> Integrăm viitorul.</h1>
                        <p>Transformăm ideile tale în soluții software performante pentru afaceri moderne.</p>
                        <div class="btn-box">
                            <a href="https://www.facebook.com/atelieruldesoftware" class="default-btn" target="_blank"><i class="bx bxl-facebook"></i>Urmărește-ne<span></span></a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="main-banner-image">
                        <img src="../assets/images/banner.png" alt="image">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ASMainBanner'
}
</script>
